import { css, genesisStyled, Image } from '@leagueplatform/genesis-commons';

export const StyledImg = genesisStyled(Image)(
  css({
    objectFit: 'cover',
  }),
);
